<template>
  <div style="margin-top:30px;">
    <el-form
      ref="form"
      :rules="rules"
      :model="form"
      label-width="100px"
    >
      <el-row>
        <el-form-item
          label="联系人"
          prop="name"
          style="margin-right:15px"
        >
          <el-input
            v-model.trim="form.name"
            @change="(value)=>{form.name = value.replace(/\s/g,'')}"
          />
        </el-form-item>
        <el-form-item
          label="手机号"
          prop="phone"
          style="margin-right:15px"
        >
          <el-input
            v-model="form.phone"
            :disabled="true"
          />
        </el-form-item>
        <el-form-item
          label="加油站名称"
          prop="gasName"
          style="margin-right:15px"
        >
          <el-input
            v-model.trim="form.gasName"
            @change="(value)=>{form.gasName = value.replace(/\s/g,'')}"
          />
        </el-form-item>
        <el-form-item
          label="加油站地址"
          prop="areaList"
          style="margin-right:15px"
        >
          <el-cascader
            v-model="form.areaList"
            :options="parentData.areaOptions"
            :props="{ value: 'countyCode', label: 'countyName', children: 'children' }"
            clearable
            @change="changeAreaList"
          />
        </el-form-item>
        <el-form-item
          label="详细地址"
          prop="address"
          style="margin-right:15px"
        >
          <el-input v-model="form.address" />
        </el-form-item>
      </el-row>
    </el-form>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="funcCancel">
        取 消
      </el-button>
      <el-button
        type="primary"
        @click="funcSubmit"
      >
        确 定
      </el-button>
    </div>
  </div>
</template>
<script>
import request from "@/utils/request";
import {validatePhone} from '@/utils/validate'

export default {
  name: "GasStationEdit",
  data() {
    return {
      emptyForm: {},
      parentData: {
        areaOptions: this.$store.state.components.areaOptions
      },
      form: {
        gasBalance: "",
        paytyCode: "",
        gasName: "",
        branchCode: "",
        provinceCode: "",
        areaList: [],
        cityCode: "",
        countyCode: "",
        address: "",
        name: "",
        phone:''
      },
      rules: {
        name: [
          { required: true, message: "请输入联系人", trigger: "blur" },
          { max:64, message: "不超过64字符" },
        ],
        phone: [
          {
            required: true,
            validator(rule, value, callback) {
              validatePhone(value)
                ? callback()
                : callback(new Error("手机号格式有误"));
            }
          }
        ],
         gasName: [
            {required: true, message: "请输加油站名称", trigger: "blur" },
            { max:255, message: "最多输入255字符" },
          ],
        address: [
          { required: true, message: "请输入详细地址" , trigger: "blur" },
          {min:1, max: 255, message:'长度为1到255个字符'}
        ],
        areaList: [
          { required: true, message: "加油站地址", trigger: "blur" },
        ]
      }
    };
  },
  created() {
    //保存空表单对象
    this.emptyForm = JSON.parse(JSON.stringify(this.form));
  },
  methods: {
    // 区域切换
    changeAreaList(value) {
      if (value.length > 0) {
        this.form.provinceCode = value[0];
        this.form.cityCode = value[1];
        this.form.countyCode = value[2];
      } else {
        this.form.provinceCode = "";
        this.form.cityCode = "";
        this.form.countyCode = "";
      }
    },
    // 获取页面信息
    getInfo(code) {
      //查询到数据之前先展示空表单
      this.$refs.form.resetFields()
      this.form = JSON.parse(JSON.stringify(this.emptyForm));
      request({
        url: `/ntocc-basic-api/gasStation/${code}`,
        method: "get"
      }).then(response => {
        this.form = response.data;
       this.$set(this.form, "areaList", []);
        if (
          this.form.provinceCode &&
          this.form.cityCode &&
          this.form.countyCode
        ) {
          this.form.areaList.push(
            this.form.provinceCode,
            this.form.cityCode,
            this.form.countyCode
          );
        }
      });
    },
    // 提交
    funcSubmit() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          const data = this.form;
          const rLoading = this.openLoading();
          request({
            url: "/ntocc-basic-api/gasStation/update",
            method: "put",
            params: data
          }).then(response => {
            rLoading.close();
            this.$message({ message: response.msg, type: "success" });
            this.$emit("fatherEditMethod");
          });
        } else {
          return false;
        }
      });
    },
    // 取消
    funcCancel() {
      this.$emit("fatherCancelMethod", "edit");
    }
  }
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  margin: 15px 0 15px 0;
  width: 175px;
  float: right;
}
</style>
